var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "51.476 20.907 180.866 173.699",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__a",
    x1: 464.49,
    y1: 419.14,
    x2: 632.75,
    y2: 419.14,
    gradientTransform: "rotate(15.61 1529.175 -1368.262)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#316fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__b",
    x1: 31.2,
    y1: 63.42,
    x2: 199.48,
    y2: 110.44,
    xlinkHref: "#facebook-icon_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__c",
    x1: 170.09,
    y1: 6.12,
    x2: 208.66,
    y2: 76.49,
    xlinkHref: "#facebook-icon_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__d",
    x1: 153.75,
    y1: -2.94,
    x2: 170.14,
    y2: 26.95,
    xlinkHref: "#facebook-icon_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__e",
    x1: 79.45,
    y1: 150.31,
    x2: 95.84,
    y2: 180.2,
    xlinkHref: "#facebook-icon_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook-icon_svg__f",
    x1: 97.95,
    y1: 159.38,
    x2: 109.89,
    y2: 181.15,
    xlinkHref: "#facebook-icon_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-3",
    d: "M79.86 20.6c-25.47 3-63 29-60.42 71.41 3.63 60.09 63.15 26.35 83 60.34S189.32 167.19 183 95.7c-5.16-58.37-45.92-81.9-103.14-75.1z",
    fill: "url(#facebook-icon_svg__a)",
    transform: "translate(32.162 20.895)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-4",
    d: "M166.81 47.5C143-14.63 75.72-7 51 20.64c-9 10-19.86 27.32-16.43 47.2a47.31 47.31 0 003.55 11.47c11 28.15-13.83 19.41-10.62 50.77 1.58 15.51 18.28 31.09 40.17 22.16 45.25-18.44 62.88 19.6 114.4-15.1 19-12.81 21.23-36.64 15-53.12-8.49-22.63-22.76-16.91-30.26-36.52z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#facebook-icon_svg__b)",
    transform: "translate(32.162 20.895)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-5",
    d: "M144.162 94.255v-11.54a3.68 3.68 0 014-4h10.25v-16.75h-14.14c-15.69 0-19.21 11.83-19.21 18.73v13.56h-11.53v16.76h11.63v41.88h18.27v-41.88h13.52l.6-6.59 1.09-10.17z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-6",
    d: "M169.41 32.86s1.23 15.5 16.54 19.33 19.18-25.68 6.13-33.77c-10.08-6.24-24 3.08-22.67 14.44z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#facebook-icon_svg__c)",
    transform: "translate(32.162 20.895)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-7",
    d: "M153.26 5.53s-4.31 7.53 3.89 10.89 13.23-7 10.35-11.75-12.37-3.6-14.24.86z",
    fill: "url(#facebook-icon_svg__d)",
    transform: "translate(32.162 20.895)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-8",
    d: "M79 158.78s-4.32 7.53 3.88 10.88 13.23-7 10.35-11.74-12.39-3.6-14.23.86z",
    fill: "url(#facebook-icon_svg__e)",
    transform: "translate(32.162 20.895)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "facebook-icon_svg__cls-9",
    d: "M99 168.06s.24 7.34 6 5.29.29-11.37-3.28-10.76c-3.4.57-2.72 5.47-2.72 5.47z",
    fill: "url(#facebook-icon_svg__f)",
    transform: "translate(32.162 20.895)"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgFacebookIcon as ReactComponent };